import type { editions as en } from '@/i18n/locales/en/editions';
import type { Translation } from '@/i18n/types';

export const editions: Translation<typeof en> = {
  fit: {
    sections: {
      home: 'Inicio',
      insights: 'Perspectivas',
      programs: 'Programas',
      content: 'Contenido',
    },
    items: {
      overview: 'Resumen',
      departments: 'Departamentos',
      users: 'Usuarios',
      vitality: 'Vitalidad',
      participation: 'Participación',
      pilots: 'Pilotos',
      challenges: 'Retos',
      communications: 'Comunicación',
      documents: 'Documentos',
      reports: 'Informes',
      settings: 'Configuración',
    },
  },
  soccer: {
    sections: {
      home: 'Inicio',
      insights: 'Perspectivas',
      programs: 'Programas',
    },
    items: {
      overview: 'Resumen',
      departments: 'Equipos',
      users: 'Jugadores',
      vitality: 'Vitalidad',
      participation: 'Participación',
      pilots: 'Pilotos',
      challenges: 'Retos',
    },
  },
};
